<div class="modal-alert--wrapper">
  <div class="modal-alert--body">
    <h3 class="modal-alert--title" nxHeadline="section">{{ data.title | translate}}</h3>
    <p class="modal-alert--text" [innerHTML]="data.message"></p>
  </div>
  <div class="modal-alert--cta--wrapper">
    <button
      *ngIf="data.hasSecondaryAction ?? true"
      class="modal-alert--cta modal-alert--cta_cancel"
      nxButton="secondary"
      (click)="onClick(false)"
    >
      {{ 'modal.buttons.discard' | translate }}
    </button>
    <button
      class="modal-alert--cta modal-alert--cta_confirm"
      nxButton="primary"
      (click)="onClick(data.uuid)"
    >
      {{ 'modal.buttons.confirm' | translate }}
    </button>
  </div>
</div>
